import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import type { Params } from "@/types";
import type { InactiveNotificationTemplate } from "@/types/notifications";

const endpoint = {
  notificationsInactive: "/notifications-inactive",
};

export const fetchNotificationsInactive = createAsyncThunk(
  "notificationsInactive/fetch",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.notificationsInactive, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error))
        return thunkAPI.rejectWithValue({ error: error.message });
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);

export const createNotificationsInactive = createAsyncThunk(
  "notificationsInactive/create",
  async (payload: Omit<InactiveNotificationTemplate, "id">, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoint.notificationsInactive,
        payload,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error))
        return thunkAPI.rejectWithValue({ error: error.message });
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);

export const updateNotificationsInactive = createAsyncThunk(
  "notificationsInactive/update",
  async (
    payload: Partial<InactiveNotificationTemplate> & { id: number },
    thunkAPI,
  ) => {
    try {
      const { id, ...body } = payload;
      const response = await axiosInstance.put(
        `${endpoint.notificationsInactive}/${id}`,
        body,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error))
        return thunkAPI.rejectWithValue({ error: error.message });
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);

export const deleteNotificationsInactive = createAsyncThunk(
  "notificationsInactive/delete",
  async (id: number, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint.notificationsInactive}/${id}`,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error))
        return thunkAPI.rejectWithValue({ error: error.message });
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);
